export default __webpack_public_path__ + "static/media/gdrive-logo.3d7aff58.png";